import { render, staticRenderFns } from "./menu-categorias-produto.html?vue&type=template&id=a5e45798&scoped=true&"
import script from "./menu-categorias-produto.vue?vue&type=script&lang=js&"
export * from "./menu-categorias-produto.vue?vue&type=script&lang=js&"
import style0 from "./menu-categorias-produto.less?vue&type=style&index=0&id=a5e45798&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e45798",
  null
  
)

export default component.exports